
import { randomArrayElement } from '../utils'

const list = [
  '23 and Me',
  'Airbnb',
  'Car2go',
  'Coinbase',
  'Digg',
  'Dropbox',
  'Eventbrite',
  'Facebook',
  'Favor',
  'GitHub',
  'HotelTonight',
  'Hulu',
  'Instacart',
  'Instagram',
  'Lime',
  'LinkedIn',
  'Lyft',
  'Meetup',
  'MyFitnessPal',
  'Netflix',
  'Nextdoor',
  'Pinterest',
  'Postmates',
  'Reddit',
  'Robinhood',
  'Shazam',
  'Slack',
  'Snapchat',
  'SoundCloud',
  'Spotify',
  'Square',
  'StubHub',
  'Tesla',
  'Tinder',
  'Twitter',
  'TripAdvisor',
  'Uber',
  'Venmo',
  'Yelp',
  'YouTube',
  'Whatsapp'
]

export const getPair = () => {
  const clonedList = list.slice(0)

  const firstPair = randomArrayElement(clonedList)

  const firstIndex = clonedList.indexOf(firstPair)

  clonedList.splice(firstIndex, 1)

  return [firstPair, randomArrayElement(clonedList)]
}
